console.log("Hello World!");
export * from './util';
export * from './desk';
export * from './domHelper';
export * from 'keycloak-js';
export { sendBackendData } from "./xhrbackend";
export { getBackendData } from "./xhrbackend";
export { API_URL } from "./config";
export { appTimetableRender } from "./appTimetable";
export { getAppCardNode } from "./appCardDefault";
export { appVoucher } from "./appVoucher";
